<template>
  <div class="loader"></div>
</template>

<style scoped>
.loader {
  aspect-ratio: 1;
  display: grid;
}

.loader::before,
.loader::after {
  content: "";
  grid-area: 1/1;

  /* Dynamically scale the balls with a percentage */
  --ball-size: calc(25%);
  --c: no-repeat radial-gradient(farthest-side, var(--color-brand-secondary) 92%, transparent 0);

  background:
    var(--c) 50% 0,
    var(--c) 50% 100%,
    var(--c) 100% 50%,
    var(--c) 0 50%;
  background-size: var(--ball-size) var(--ball-size);
  animation: l12 1s infinite;
}

.loader::before {
  margin: 4%;
  background-size: calc(var(--ball-size) * 0.7) calc(var(--ball-size) * 0.7);
  /* Slightly smaller */
  filter: hue-rotate(45deg);
  animation-timing-function: linear;
}

@keyframes l12 {
  100% {
    transform: rotate(0.5turn);
  }
}
</style>